import {
  faDownload,
  faExclamationCircle,
  faFileExcel,
  faPlus,
  faSearch,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef } from "react";
import { TableChangeHandler } from "react-bootstrap-table-next";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, Navigate, useLocation } from "react-router-dom";
import MultipleCheckboxes from "../../../components/MultipleCheckboxes";
import CategoryRepository from "../../../repositories/Brand/CategoryRepository";
import StokProductRepository from "../../../repositories/Brand/StockProductRepository";
import CategoryRepositoryVendor from "../../../repositories/Vendor/CategoryRepository";
import StokProductVendorRepository from "../../../repositories/Vendor/StokProductRepository";
import BrandVendorRepository from "../../../repositories/Brand/VendorRepository";
import { RootState } from "../../../stores";
import VuiBreadcrumb from "../../../vodea/@vodea-ui/components/VuiBreadcrumb";
import useRoleService from "../../../vodea/utilities/hooks/useRoleService";
import { showToast } from "../../../vodea/utilities/helpers/global";
import VuiActionModal from "../../../vodea/@vodea-ui/components/Modal/VuiActionModal";
import { $clone, defaultActionFormatter } from "../../../vodea/utilities";
import fileDownload from "js-file-download";
import VuiDataTable from "../../../vodea/@vodea-ui/components/VuiDataTable";
import { useState } from "@hookstate/core";
import useIsMounted from "../../../vodea/utilities/hooks/useIsMounted";
import _ from "lodash";
import moment from "moment";
import UpdateStockModal from "../../../components/Modal/UpdateStockModal";
import ExportBrandRepository from "../../../repositories/Export/Brand/ExportBrandRepositories";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VuiLoader from "../../../vodea/@vodea-ui/components/VuiLoader";
import ProductRepositories from "../../../repositories/Widget/ProductRepositories";
import VuiNumberFormat from "../../../vodea/@vodea-ui/components/VuiNumberFormat";
import ProductRepository from "../../../repositories/Widget/Vendor/ProductRepository";

const Stok: React.FC<any> = () => {
  const { t } = useTranslation();

  const isMounted = useIsMounted();

  const { role_id } = useSelector((state: RootState) => {
    return state.system.user;
  });

  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const location = useLocation();

  const { brand } = useSelector((state: RootState) => state.brand);
  const { vendor } = useSelector((state: RootState) => state.vendor);

  const [vendorList, setVendorOption] = React.useState<any>([]);
  const defaultCategory = useState<any[]>([]);
  const defaultVendor = useState<any[]>([]);

  const [categoryList, setCategoryOption] = React.useState<any>([]);
  const [dataProduct, setDataProduct] = React.useState<any>([]);
  const [tableData, setTableData] = React.useState<any>([]);
  const [deletedProduct, setDeletedProduct] = React.useState("");
  const hiddenFileInput = useRef<HTMLInputElement>(null);
  const [showModalError, setShowModalError] = React.useState<boolean>(false);
  const errorsUploadStock = useState<any[]>([]);
  const inStockRate = useState(0);
  const weeksOfSupplyLoading = useState<boolean>(false);
  const weeksOfSupply = useState(0);
  const runRate = useState(0);
  const averageInstockRate = useState(0);
  const averageInstockRateLoading = useState<boolean>(false);

  const { isAdministrator, isKeyAccount, isBrand, isVendor } = useRoleService();

  const selectedStock = useState<any>(null);
  const showStockModal = useState(false);

  const tableConfig = useState({
    search: "",
    page: 1,
    per_page: 10,
    sorted_by: "asc",
    order_by: "products.name",
    total: 0,
    loading: false,
  });

  const filterConfigLoading = useState(false);

  const handleExport = () => {
    let params: any = {};
    Object.assign(params, {
      vendor: defaultVendor.value,
      category: defaultCategory.value,
    });
    ExportBrandRepository.exportProductStock(brand.id, params).then(
      (response: any) => {
        const fileName = `${moment().format(
          "YYYY-MM-DD HH:mm:ss"
        )} stock_product .xlsx`;

        fileDownload(response.data, fileName);
      }
    );
  };

  const changeTableLoading = (val: boolean) => {
    if (isMounted.current) {
      tableConfig.loading.set(val);
    }
  };

  const fetchDataToTable = (data: any) => {
    const tempDataProduct: any = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i] != null) {
        const categoryName = data[i].category_name;
        const productName = data[i].name;
        const imageURL = data[i].photos
          ? data[i].photos.length != 0
            ? data[i].photos[0].url
            : "data:image/png;base64,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"
          : "";
        const sku = data[i].sku;
        const tempData = {
          id: data[i].id,
          products: {
            name: productName,
            image: imageURL,
          },
          category_name: categoryName,
          sku: sku,
          sku_channels: data[i].sku_channels ? data[i].sku_channels : "-",
          stock_quantity:
            isVendor() || isBrand() || isAdministrator()
              ? data[i].vendor_stock
              : data[i].available_stock,
          in_stock_rate: "62.24%",
          run_rate: data[i].run_rate,
          weeks_of_supply: data[i].weeks_of_supply,
        };
        tempDataProduct.push(tempData);
      }
    }
    setTableData(tempDataProduct);
  };

  const fetchDataToOptions = (data: any) => {
    const categoryDatas = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i] != null) {
        const categoryData = {
          value: i + 1,
          label: data[i].name,
          id: data[i].id,
        };
        categoryDatas.push(categoryData);
      }
    }
    return categoryDatas;
  };

  const fetchVendorOptions = () => {
    if (!isVendor()) {
      BrandVendorRepository.all(brand.id, {
        per_page: 1000,
      }).then((res: any) => {
        const fullData = res.data.data;
        const vendorDatas = fetchDataToOptions(fullData);

        setVendorOption(fullData);
        defaultVendor.set(
          fullData.map((option: any) => {
            return option.id;
          })
        );
      });
    }
  };

  const fetchCategoryOptions = () => {
    if (!isVendor()) {
      // CategoryRepository.all(brand.id).then((res: any) => {
      //   const fullData = res.data.data;
      //

      //   setCategoryOption(fullData);
      //   defaultCategory.set(fullData.map((option: any) => {
      //     return option.id;
      //   }))
      // });
      CategoryRepository.all(brand.id, {
        with: "children",
        only: "parent",
        per_page: 1000,
      }).then((response: any) => {
        const fullData = response.data.data;
        setCategoryOption(fullData);
        const data: any = [];
        fullData.map((option: any) => {
          data.push(option.id);
          option.children.map((child: any) => {
            data.push(child.id);
          });
        });

        defaultCategory.set(data);
      });
    } else if (isVendor()) {
      CategoryRepositoryVendor.all(vendor.id, {
        with: "children",
        only: "parent",
        per_page: 1000,
      }).then((response: any) => {
        const fullData = response.data.data;
        setCategoryOption(fullData);
        const data: any = [];
        fullData.map((option: any) => {
          data.push(option.id);
          option.children.map((child: any) => {
            data.push(child.id);
          });
        });

        defaultCategory.set(data);
      });
    }
  };

  const fetchProductData = async (reset: boolean = false) => {
    if (reset) tableConfig.page.set(1);

    changeTableLoading(true);

    const conf = _.omit($clone(tableConfig.value), "loading");

    let params: any = {};
    Object.keys(conf).forEach((prop) => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    Object.assign(params, {
      with: ["photos"],
      category: defaultCategory.value,
    });

    if (params.order_by === "stock_quantity") {
      if (isVendor()) {
        params.order_by = "vendor_stock";
      } else {
        params.order_by = "available_stock";
      }
    }

    setDataProduct([]);

    if (!isVendor()) {
      Object.assign(params, {
        vendor: defaultVendor.value,
      });

      StokProductRepository.all(brand.id, params)
        .then((res: any) => {
          const fullData = res.data.data;
          tableConfig.total.set(res.data.meta.total);
          setDataProduct(fullData);
          fetchDataToTable(fullData);
          changeTableLoading(false);
        })
        .catch((e: any) => {
          changeTableLoading(false);
        });
    }

    if (isVendor()) {
      StokProductVendorRepository.all(vendor.id, params)
        .then((res: any) => {
          const fullData = res.data.data;
          tableConfig.total.set(res.data.meta.total);
          setDataProduct(res.data.data);
          fetchDataToTable(fullData);
          changeTableLoading(false);
        })
        .catch((e: any) => {
          changeTableLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchVendorOptions();

    fetchCategoryOptions();

    fetchProductData();
  }, []);

  const getRunRate = () => {
    filterConfigLoading.set(true);
    let params: any = {};
    Object.assign(params, {
      category: defaultCategory.value,
      vendor: defaultVendor.value,
    });
    if (isVendor()) {
      delete params.vendor;
      ProductRepository.getRunRate(vendor?.id, params)
        .then((resp: any) => {
          if (isMounted.current) {
            filterConfigLoading.set(false);
            runRate.set(resp.data.data);
          }
        })
        .catch((e: any) => {
          if (isMounted.current) filterConfigLoading.set(false);
        });
    } else {
      ProductRepositories.getRunRate(brand?.id, params)
        .then((resp: any) => {
          if (isMounted.current) {
            filterConfigLoading.set(false);
            runRate.set(resp.data.data);
          }
        })
        .catch((e: any) => {
          if (isMounted.current) filterConfigLoading.set(false);
        });
    }
  };

  const getAverageInStockRate = () => {
    averageInstockRateLoading.set(true);
    let params: any = {};
    Object.assign(params, {
      category: defaultCategory.value,
      vendor: defaultVendor.value,
    });
    ProductRepositories.getAvgInStockRate(brand?.id, params)
      .then((resp: any) => {
        if (isMounted.current) {
          averageInstockRateLoading.set(false);
          averageInstockRate.set(resp.data.data);
        }
      })
      .catch((error: any) => {
        if (isMounted.current) averageInstockRateLoading.set(false);
      });
  };

  const getWeeksOfSupply = () => {
    weeksOfSupplyLoading.set(true);
    let params: any = {};
    Object.assign(params, {
      category: defaultCategory.value,
      vendor: defaultVendor.value,
    });
    if (isVendor()) {
      delete params.vendor;
      ProductRepository.getWOS(vendor?.id, params)
        .then((resp: any) => {
          if (isMounted.current) {
            weeksOfSupplyLoading.set(false);
            weeksOfSupply.set(resp.data.data);
          }
        })
        .catch((error: any) => {
          if (isMounted.current) {
            weeksOfSupplyLoading.set(false);
          }
        });
    } else {
      ProductRepositories.getWOS(brand?.id, params)
        .then((resp: any) => {
          if (isMounted.current) {
            weeksOfSupplyLoading.set(false);
            weeksOfSupply.set(resp.data.data);
          }
        })
        .catch((error: any) => {
          if (isMounted.current) {
            weeksOfSupplyLoading.set(false);
          }
        });
    }
  };

  useEffect(() => {
    if (!isVendor()) {
      getAverageInStockRate();
    }
    getWeeksOfSupply();
    getRunRate();
  }, []);

  const handleTableSearch = _.debounce(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      tableConfig.search.set(e.target.value);
      tableConfig.page.set(1);

      fetchProductData();
    },
    300
  );

  const onTableChange: TableChangeHandler<any> = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    tableConfig.page.set(page);
    tableConfig.per_page.set(sizePerPage);
    tableConfig.order_by.set(sortField);
    tableConfig.sorted_by.set(sortOrder);

    fetchProductData();
  };

  const handleDownload = () => {
    StokProductVendorRepository.download(vendor.id).then((response: any) => {
      const fileName = `${moment().format(
        "YYYY-MM-DD HH:mm:ss"
      )} stock product.xlsx`;

      fileDownload(response.data, fileName);
    });
  };

  const handleDownloadPrice = () => {
    ExportBrandRepository.downloadProductPrice(brand.id).then(
      (response: any) => {
        const fileName = `${moment().format(
          "YYYY-MM-DD HH:mm:ss"
        )} stock product price.xlsx`;

        fileDownload(response.data, fileName);
      }
    );
  };

  const defaultImageSrc = (ev: any) => {
    ev.target.src =
      "data:image/png;base64,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";
  };

  if (role_id === 2) {
    return <Navigate to={"/stock/manajemen"} replace />;
  }

  const handleShowModalError = (errors: any) => {
    setShowModalError(true);
    errorsUploadStock.set(errors);
  };

  const handleFile = async (event: any) => {
    const file = event.target.files[0];

    const form = new FormData();

    form.append("file", file);

    StokProductVendorRepository.import(vendor.id, form)
      .then((res: any) => {
        if (isMounted.current) {
          showToast(t("response.successUpdateData"), "success");
          fetchProductData(true);
        }
      })
      .catch((err: any) => {
        if (
          isMounted.current &&
          err.isAxiosError &&
          err.response.data.errors.length > 0
        ) {
          handleShowModalError(err.response.data.errors);
          showToast(err.message, "error");
        }
      });
  };

  const handleFilePrice = async (event: any) => {
    const file = event.target.files[0];

    const form = new FormData();

    form.append("file", file);

    ExportBrandRepository.importProductPrice(brand.id, form)
      .then((res: any) => {
        if (isMounted.current) {
          showToast(t("response.successUpdateData"), "success");
          fetchProductData(true);
        }
      })
      .catch((err: any) => {
        if (
          isMounted.current &&
          err.isAxiosError &&
          err.response.data.errors.length > 0
        ) {
          handleShowModalError(err.response.data.errors);
          showToast(err.message, "error");
        }
      });
  };

  function tableActionDelete(id: any) {
    setDeletedProduct(id);
    handleShow();
  }

  function handleDeleteProduct(id: any) {
    handleClose();
    const dataTable = [...tableData];
    for (var i = 0; i < dataTable.length; i++) {
      if (dataTable[i].id == id) {
        dataTable.splice(i, 1);
      }
    }
    setTableData(dataTable);
    StokProductRepository.delete(brand.id, id).then((res: any) => {});
  }

  function ProductFormatter(cell: any, row: any) {
    return (
      <div className="product-wrapper">
        <div className="product-image">
          <img
            src={row.products.image}
            alt={"image-product"}
            onError={defaultImageSrc}
          />
        </div>
        {row.products.name}
      </div>
    );
  }

  const fulfillmentTableColumnsAdmin = [
    {
      dataField: "products.name",
      text: t("stock.index.table.produk"),
      formatter: ProductFormatter,
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "category_name",
      text: t("stock.index.table.kategori"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "sku",
      text: t("stock.index.table.sku"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "sku_channels",
      text: t("stock.index.table.sku_produk"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "stock_quantity",
      text: t("stock.index.table.ketersediaan"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "run_rate",
      text: t("stock.index.table.run_rate"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "weeks_of_supply",
      text: t("stock.index.table.wos"),
      sort: true,
      classes: "valign-middle",
      formatter: (cell: any) => {
        return <div>{cell}</div>;
      },
    },
    {
      dataField: "edit",
      text: "Action",
      sort: false,
      headerAlign: "center",
      formatter: defaultActionFormatter,
      formatExtraData: {
        location: location.pathname,
        actionDelete: tableActionDelete,
        permission: isAdministrator() || isKeyAccount() ? "any" : "brand",
        permissions: ["brand.update"],
      },
      classes: "valign-middle",
    },
  ];

  const fulfillmentTableColumnsNonAdmin = [
    {
      dataField: "products.name",
      text: t("stock.index.table.produk"),
      formatter: ProductFormatter,
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "category_name",
      text: t("stock.index.table.kategori"),
      sort: false,
      classes: "valign-middle",
    },
    {
      dataField: "sku",
      text: t("stock.index.table.sku"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "stock_quantity",
      text: t("stock.index.table.ketersediaan"),
      sort: false,
      classes: "valign-middle",
    },
    {
      dataField: "run_rate",
      text: t("stock.index.table.run_rate"),
      sort: true,
      classes: "valign-middle",
    },
    {
      dataField: "weeks_of_supply",
      text: t("stock.index.table.wos"),
      sort: true,
      classes: "valign-middle",
      formatter: (cell: any) => {
        return <div>{cell}</div>;
      },
    },
    {
      dataField: "action",
      text: "Action",
      sort: false,
      headerAlign: "center",
      formatter: (cell: any, row: any) => {
        return (
          <div className={"table-btn-wrapper"}>
            <button
              type={"button"}
              className={"btn btn-primary btn-small"}
              onClick={() => handleShowStockModal(row)}
            >
              {t("button.update")}
            </button>
          </div>
        );
      },
      classes: "valign-middle",
    },
  ];

  const handleShowStockModal = async (stock: any) => {
    const tempStock = {
      id: _.get(stock, "id"),
      name: _.get(stock, "products.name"),
      sku: _.get(stock, "sku"),
      stock: _.get(stock, "stock_quantity"),
    };

    await selectedStock.set(tempStock);

    showStockModal.set(true);
  };

  const breadcrumbList = [
    {
      label: t("stock.title"),
      link: "/stock",
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("stock.title")}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <Modal
        show={showModalError}
        onHide={() => setShowModalError(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className={"d-block modal-list-error"}>
          {Object.values(errorsUploadStock.get()).map(
            (error: any, index: number) => {
              return (
                <ul>
                  <li key={index} className={"text-danger"}>
                    {error}
                  </li>
                </ul>
              );
            }
          )}
        </Modal.Body>
      </Modal>

      <div className={"page-header-component"}>
        <div className="title-action-wrapper">
          <h3 className={"title"}>{t("stock.title")}</h3>
        </div>

        {isAdministrator() || isKeyAccount() ? (
          <div className="action-wrapper">
            <div className="btn-wrapper d-grid">
              {tableData.length > 0 ? (
                <button
                  type={"button"}
                  className={"btn btn-primary"}
                  onClick={handleDownloadPrice}
                >
                  <FontAwesomeIcon
                    className={"icon icon-prefix"}
                    icon={faDownload}
                  />
                  {t("stock.index.vendor.button.download")}
                </button>
              ) : null}
            </div>

            <div className="btn-wrapper d-grid me-2 ms-2">
              <button
                type={"button"}
                className={"btn btn-info"}
                onClick={() => {
                  if (hiddenFileInput.current) {
                    hiddenFileInput.current.click();
                  }
                }}
              >
                <FontAwesomeIcon
                  className={"icon icon-prefix"}
                  icon={faUpload}
                />
                {t("stock.index.vendor.button.upload")}
              </button>

              <input
                ref={hiddenFileInput}
                style={{ display: "none" }}
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFilePrice}
              />
            </div>
            <Link
              to={"/stock/create"}
              type={"button"}
              className={"btn btn-primary action-item"}
            >
              <FontAwesomeIcon className={"icon icon-prefix"} icon={faPlus} />
              {t("stock.index.button.add")}
            </Link>
            <div className="btn-wrapper d-grid">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleExport}
              >
                <FontAwesomeIcon
                  icon={faFileExcel}
                  className="icon icon-prefix"
                />
                {t("button.export")}
              </button>
            </div>
          </div>
        ) : isVendor() ? (
          <div className="default-btn-action-wrapper mb-0">
            {tableData.length > 0 ? (
              <button
                type={"button"}
                className={"btn btn-primary"}
                onClick={handleDownload}
              >
                <FontAwesomeIcon
                  className={"icon icon-prefix"}
                  icon={faDownload}
                />
                {t("stock.index.vendor.button.download")}
              </button>
            ) : null}

            <button
              type={"button"}
              className={"btn btn-info"}
              onClick={() => {
                if (hiddenFileInput.current) {
                  hiddenFileInput.current.click();
                }
              }}
            >
              <FontAwesomeIcon className={"icon icon-prefix"} icon={faUpload} />
              {t("stock.index.vendor.button.upload")}
            </button>

            <input
              ref={hiddenFileInput}
              style={{ display: "none" }}
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              onChange={handleFile}
            />
          </div>
        ) : isBrand() ? (
          <div className="btn-wrapper">
            <button
              type="button"
              className="btn btn-success"
              onClick={handleExport}
            >
              <FontAwesomeIcon
                icon={faFileExcel}
                className="icon icon-prefix"
              />
              {t("button.export")}
            </button>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="card-paper mb-4">
        <div className="card-content">
          <div className="card-filter-section">
            <div className="row">
              {!isVendor() ? (
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">
                      {t("stock.index.option.vendor")}
                    </label>
                    <MultipleCheckboxes
                      name={"vendor"}
                      options={vendorList}
                      labelOption="name"
                      valueOption="id"
                      values={defaultVendor.value}
                      onChange={(values) => {
                        defaultVendor.set(values);
                        if (!isVendor()) {
                          getAverageInStockRate();
                        }
                        getRunRate();
                        getWeeksOfSupply();
                        fetchProductData(true);
                      }}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("stock.index.option.kategori")}
                  </label>
                  <MultipleCheckboxes
                    name={"kategori"}
                    options={categoryList}
                    labelOption="name"
                    valueOption="id"
                    values={defaultCategory.value}
                    onChange={(values) => {
                      defaultCategory.set(values);
                      if (!isVendor()) {
                        getAverageInStockRate();
                      }
                      getRunRate();
                      getWeeksOfSupply();
                      fetchProductData(true);
                    }}
                    children={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={"card-chart-wrapper"}>
        <div className={"card-chart"}>
          {filterConfigLoading.get() ? (
            <VuiLoader />
          ) : (
            <>
              <label className="card-title">
                Average Run Rate
                <OverlayTrigger
                  key={`tooltip-overlay-gmv`}
                  placement={"top"}
                  overlay={
                    <Tooltip id={`tooltip-gmv`}>
                      <i>Rata rata unit terjual dari 7 hari kebelakang</i>
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    className={"icon"}
                    icon={faExclamationCircle}
                  />
                </OverlayTrigger>
              </label>

              <label className="card-note">
                <span className={"percentage-stock"}>
                  <VuiNumberFormat data={runRate.get()} value={runRate.get()} />
                </span>
              </label>
            </>
          )}
        </div>
        <div className={"card-chart"}>
          {weeksOfSupplyLoading.get() ? (
            <VuiLoader />
          ) : (
            <>
              <label className="card-title">
                Weeks Of Supply
                <OverlayTrigger
                  key={`tooltip-overlay-gmv`}
                  placement={"top"}
                  overlay={
                    <Tooltip id={`tooltip-gmv`}>
                      <i>Nilai total rata-rata dari item yang ada</i>
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    className={"icon"}
                    icon={faExclamationCircle}
                  />
                </OverlayTrigger>
              </label>

              <label className="card-note">
                <span className={"percentage-stock"}>
                  {weeksOfSupply.get()}
                </span>
              </label>
            </>
          )}
        </div>
        {!isVendor() ? (
          <div className={"card-chart"}>
            {averageInstockRateLoading.get() ? (
              <VuiLoader />
            ) : (
              <>
                <label className="card-title">
                  Average In Stock Rate
                  <OverlayTrigger
                    key={`tooltip-overlay-gmv`}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-gmv`}>
                        <i>Rata-rata persentase in stock rate pada vendor</i>
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon
                      className={"icon"}
                      icon={faExclamationCircle}
                    />
                  </OverlayTrigger>
                </label>

                <label className="card-note">
                  <span className={"percentage-stock"}>
                    {averageInstockRate.get()}%
                  </span>
                </label>
              </>
            )}
          </div>
        ) : null}
      </div>

      <div className="card-paper mb-4 mt-4">
        <div className="card-content">
          <div className={"default-filter-section"}>
            <div className={"filter-item filter-special type-search"}>
              <div className="input-group prefix-group">
                <span className="input-group-text">
                  <FontAwesomeIcon
                    className={"icon icon-prefix"}
                    icon={faSearch}
                  />
                </span>
                <input
                  defaultValue={tableConfig.search.get()}
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={handleTableSearch}
                />
              </div>
            </div>
          </div>

          <VuiDataTable
            loading={tableConfig.loading.get()}
            columns={
              isAdministrator() || isKeyAccount() || isBrand()
                ? fulfillmentTableColumnsAdmin
                : fulfillmentTableColumnsNonAdmin
            }
            data={tableData}
            page={tableConfig.page.get()}
            sizePerPage={tableConfig.per_page.get()}
            totalSize={tableConfig.total.get()}
            onTableChange={onTableChange}
          />

          <VuiActionModal
            show={show}
            onHide={handleClose}
            onContinue={() => handleDeleteProduct(deletedProduct)}
          />
        </div>
      </div>

      <UpdateStockModal
        stock={$clone(selectedStock.get())}
        show={showStockModal.get()}
        onContinue={() => {
          showStockModal.set(false);
          fetchProductData();
        }}
        onHide={() => showStockModal.set(false)}
      />
    </>
  );
};

export default Stok;
